import { defineAction } from '../utils/defineAction';

const INIT = 'INIT';
const SUCCESS = 'SUCCESS';
const ERROR = 'ERROR';

const httpActions = [INIT, SUCCESS, ERROR];

export const PHARMA_REPLACE = defineAction(
  'PHARMA_REPLACE',
  ['CHANGE_STEP', 'VERIFY_PATIENT_INFO', 'CLEAR'],
);

export const SUBMIT_PHARMA_REPLACE_FORM = defineAction(
  'SUBMIT_PHARMA_REPLACE_FORM',
  httpActions,
);
